import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { RequestFormService } from '../../service/requestForm/request-form.service';

@Component({
  selector: 'app-custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss'],
})
export class CustomDropdownComponent {
  @Input() items!: any[];
  @Input() formSubmitted!: boolean;
  @Input() form!: FormGroup;
  @Input() label!: string;
  @Input() controlname: FormControl | any;
  @Input() required?: boolean | any = false;
  @Input() readonly?: boolean | any = false;
  @Input() requiredErrorMessage: string | any = 'Please select an option';
  @Output() onSelectedChanged = new EventEmitter<any>();
  @Input() placeholder?: any;
  constructor(private requestFormService: RequestFormService) {}
  ngOnInit() {
    if (this.placeholder && !this.controlname.value) {
    this.controlname.setValue(null);
  }

  if (this.readonly) {
    this.controlname.disable({ emitEvent: false });
  }
  }
  onSelectChange(value: any): void {
    this.onSelectedChanged.emit(value);
  }

  get formControl() {
    return this.form.get(this.controlname);
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
